import { ActionReducerMap } from '@ngrx/store';
import * as fromCore from '@core/reducers';
import * as fromSelectedFollow from '@app/modules/follow/reducers/follow.reducer';

export interface FollowModuleState {
  follow: fromSelectedFollow.State;
}

export interface State extends fromCore.State {
  followModule: FollowModuleState;
}

export const reducers: ActionReducerMap<FollowModuleState> = {
  follow: fromSelectedFollow.reducer
};
